<template>
    <div class="order_manage_list_box">
        <el-row :gutter="20">
            <el-col :lg="6" :md="8"
                v-for="(item,index) in order_list"
                :key="index">
                <a href="javascript:;"
                    @click="handleOpen(item.month)"
                    class="order_manage_list">
                    <el-card shadow="hover" style="height: 100px;">
                        <!-- 时间 -->
                        <div class="order_manage_list_time">
                            <span class="order_manage_list_title">{{$t("message.corder.list1")}}</span>
                            <span>{{item.month}}</span>
                        </div>
                        <!-- 小计 -->
                        <div class="order_manage_list_subtotal">
                            <span class="order_manage_list_title">{{$t("message.corder.list2")}}</span>
                            <span>{{currency}}</span>
                            <span class="order_manage_list_price">{{item.money}}</span>
                        </div>
                    </el-card>
                </a>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
    computed: mapState({
        currency: state => state.currency,
        order_list: state => state.order.order_list
    }),
    methods: {
        ...mapActions([
            "getOrderMonth"
        ]),
        handleOpen(month){
            this.getOrderMonth({
                month,
				page:1,
                order_sn: sessionStorage.getItem('order_sn') || '',
                department_id: sessionStorage.getItem('department_id') || '',
                user_id: sessionStorage.getItem('user_id') || '',
                release: sessionStorage.getItem('release') || '',
                relend: sessionStorage.getItem('relend') || ''
            })
        }
    },
}
</script>

<style scoped>
/* 组件盒子 */
.order_manage_list_box{
    height: 500px;
    padding: 20px;
    overflow: hidden;
    overflow-y: auto;
    border-top: 1px solid #EBEEF5;
    border-bottom: 1px solid #EBEEF5;
    background: #fff;
}
/* 项目容器 */
.order_manage_list{
    display: block;
    width: 100%;
    margin-bottom: 20px;
}
/* 时间容器 */
.order_manage_list_time{
    margin-bottom: 5px;
}
/* 项目标题 */
.order_manage_list_title{
    color: #909399;
}
/* 价格 */
.order_manage_list_price{
    margin-left: 5px;
    color: #FF6700;
    font-size: 17px;
    font-weight: bold;
}
/* 滚轮样式 */
.order_manage_list_box::-webkit-scrollbar{
    width: 4px;
    height: 4px;
    background-color: #ddd;
}
.order_manage_list_box::-webkit-scrollbar-thumb{
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 5px;
}
</style>
